export const AUTOMATIC_PAYMENT_REMINDERS_MAX_DAYS = 90
